<template>
  <div class="cine">
    <div class="cine-head">{{ $t('video.hot') }}</div>
    <div class="grid">
      <div class="card" v-for="m in movies" :key="m.id" @click="goPlay(m.id)">
        <img :src="m.pic" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import { movieList } from './catalog';

export default {
  data() {
    return {
      movies: movieList(),
    };
  },
  methods: {
    goPlay(id) {
      this.$router.push({ path: '/PlayVideo', query: { id } });
    },
  },
  created() {
    document.title = this.$t('video.video');
  },
};
</script>

<style scoped>
.cine {
  min-height: 100vh;
  background: #fff;
  padding: 16px 16px 160px;
}
.cine-head {
  display: flex;
  align-items: center;
  font-size: 30px;
  font-weight: 800;
  color: #222;
  margin: 8px 8px 18px;
}
.cine-head::before {
  content: "";
  width: 8px;
  height: 28px;
  background: #ff2d6f;
  border-radius: 8px;
  margin-right: 10px;
}
.grid {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -6px;
}
.card {
  width: 50%;
  padding: 6px;
  box-sizing: border-box;
}
.card img {
  width: 100%;
  height: 240px;
  object-fit: cover;
  display: block;
  border-radius: 8px;
  background: #111;
}
</style>
